import Api from './index';

const getLessonPlan = (params: any) => Api.get(`users/me/lesson-plans`, { params });

export { getLessonPlan };
